<template>
    <div class="page-body notification-confirm-modal">
        <NoButtonModal :open="open" @close="$emit('cancel')">
            <div class="modal-content-header bottom-20">
                <span style="font-size: 20px; font-weight: bold; margin-left: 20px">{{ title }}</span>
            </div>
            <div class="d-flex flex-column align-items-center">
                <p class="w-80 mx-4 confirm-message">{{ message }}</p>
                <div class="my-4 d-flex justify-content-center">
                    <button
                        type="button"
                        class="primary btn-save"
                        :class="{ 'dark-red-btn': danger }"
                        @click="$emit('confirm')"
                    >
                        {{ confirmLabel }}
                    </button>
                    <button type="button" class="no-bg btn-cancel px-4" @click="$emit('cancel')">
                        {{ cancelLabel }}
                    </button>
                </div>
            </div>
        </NoButtonModal>
    </div>
</template>

<script>
    import NoButtonModal from '@/components/general/modals/NoButtonModal.vue';

    export default {
        name: 'ConfirmModal',
        components: {
            NoButtonModal,
        },
        props: {
            open: {
                type: Boolean,
                default: false,
            },
            title: {
                type: String,
                required: true,
            },
            message: {
                type: String,
                required: true,
            },
            confirmLabel: {
                type: String,
                default: 'Confirm',
            },
            cancelLabel: {
                type: String,
                default: 'Cancel',
            },
            danger: {
                type: Boolean,
                default: false,
            },
        },
    };
</script>

<style scoped>
    .modal-content-header {
        background-color: #f1f7ff;
        padding: 10px;
        display: flex;
        align-items: center;
    }

    .confirm-message {
        color: #666c6d;
        margin: 0;
        white-space: pre-line;
    }

    .btn-save {
        border-radius: 10px;
        background: #5155c3 !important;
        box-shadow: 0px 10px 5px 0px rgba(0, 0, 0, 0.03);
    }

    .btn-save.dark-red-btn {
        background: #ac2734 !important;
    }

    button.no-bg:hover {
        background: none;
    }

    .btn-cancel,
    .btn-cancel:hover {
        border-radius: 10px;
        border: 2px solid #ac2734;
    }
</style>

<style>
    .page-body.notification-confirm-modal {
        padding: 0;
    }

    .notification-confirm-modal .modal__content {
        padding: 0;
        border-radius: 10px;
        min-height: fit-content;
    }
</style>
